import { useCallback, useEffect } from 'react';

import { Outlet } from 'react-router';

import { useUrlParams } from '@/_navigation';
import { snackbar, logger } from '@/_shared';

import { useGlobalData } from './actions';
import { CacheContext } from './context';
import OverrideConsentModal from './override-modal';

export function CacheProvider() {
  const { paramLeadId } = useUrlParams();
  const cached = useGlobalData();
  const [isOverrideModalOpen, overrideModal] = cached.overrideModalCtrl;

  const handleOverrideModal = useCallback(
    (v: boolean) => {
      if (v) {
        cached.resetCustomerConsent();
        snackbar.info('You can now proceed with the checkout process.');
      } else {
        overrideModal.setFalse();
      }
    },
    [cached, overrideModal]
  );

  useEffect(() => {
    if (paramLeadId) {
      logger.setId({ lead_id: paramLeadId });
    }
  }, [paramLeadId]);

  useEffect(() => {
    if (!cached.checkout.termsReviewedByCustomer) {
      overrideModal.setFalse();
    }
  }, [cached.checkout.termsReviewedByCustomer, overrideModal]);

  return (
    <CacheContext.Provider value={cached}>
      <OverrideConsentModal isOpen={isOverrideModalOpen} onClose={handleOverrideModal} />
      <Outlet />
    </CacheContext.Provider>
  );
}
